import React from 'react';

export * as routes from './config/routes';

export default React.lazy(() => import('./Corezoid'));